import { render, staticRenderFns } from "./EditGroupDialog.vue?vue&type=template&id=5660db02&scoped=true"
import script from "./EditGroupDialog.vue?vue&type=script&lang=js"
export * from "./EditGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./EditGroupDialog.vue?vue&type=style&index=0&id=5660db02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5660db02",
  null
  
)

export default component.exports